import { useState } from 'react';
import { Location } from '../../types/schema';

interface DeleteLocationModalProps {
    location: Location;
    equipmentCount: number;
    onClose: () => void;
    onConfirm: () => void;
}

export const DeleteLocationModal = ({ location, equipmentCount, onClose, onConfirm }: DeleteLocationModalProps) => {
    const [deleting, setDeleting] = useState(false);

    const handleDelete = async () => {
        setDeleting(true);
        await onConfirm();
        setDeleting(false);
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header modal-header-danger">
                    <h2>Delete Location?</h2>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>
                <div className="modal-body">
                    <p>Are you sure you want to delete <strong>{location.name}</strong>?</p>
                    {equipmentCount > 0 && (
                        <div className="modal-warning">
                            <p>
                                <strong>{equipmentCount} pieces of equipment</strong> are currently assigned to this location. They will become unassigned but their records will be preserved.
                            </p>
                        </div>
                    )}
                </div>
                <div className="modal-footer">
                    <button className="modal-btn-cancel" onClick={onClose}>Cancel</button>
                    <button className="modal-btn-danger" onClick={handleDelete} disabled={deleting}>
                        {deleting ? 'Deleting...' : 'Delete Location'}
                    </button>
                </div>
            </div>
        </div>
    );
};
